

export const SMA_PORTFOLIO_CONFIG = {
    cutoffPercent: 80,
    sectorTolerance: 0.0,
    maxPerHolding: 0.0,
    blacklist: null,
    screener: null,
    linkedPortfolio: null,
    useSubsetInScreen: true,
    weightScheme: "prorata",
}




export const formatLinkedSmaPortfolioConfigPayload = (config, linkedPortfolio)=>{
    return {
        linked_portfolio: {
            id: linkedPortfolio.id,
            name: linkedPortfolio.name
        },
        sma_config: {
            cutoff_weight: config.cutoffPercent * 0.01,
            min_weight_tolerance: config.sectorTolerance,
            max_per_holding: config.maxPerHolding * 0.01 || 0,
            blacklist_id: config.blacklist,
            screener_id: config.screener,
            fill_type: config.weightScheme
        },
    }
}


export const reverseFormattedPortfolioProperties = (props, linkedPortfolio)=>{
    return {
        cutoffPercent: props?.cutoff_weight * 100 || 80,
        sectorTolerance: props?.min_weight_tolerance,
        maxPerHolding: props?.max_per_holding * 100 || 0,
        blacklist: props?.blacklist_id,
        screener: props?.screener_id,
        weightScheme: props?.fill_type,
        linkedPortfolio: linkedPortfolio
    }
}